import script from "./LogsPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogsPagination.vue?vue&type=script&setup=true&lang=ts"

import "./LogsPagination.vue?vue&type=style&index=0&id=54ee896c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ee896c"]])

export default __exports__